import { render } from "./CardScorm.vue?vue&type=template&id=294a0c3c&scoped=true"
import script from "./CardScorm.vue?vue&type=script&lang=js"
export * from "./CardScorm.vue?vue&type=script&lang=js"

import "./CardScorm.vue?vue&type=style&index=0&id=294a0c3c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294a0c3c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
